import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contain" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-total" }
const _hoisted_4 = { class: "header-search" }
const _hoisted_5 = { class: "header-btn" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "operation-box" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "foot" }
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = { class: "dialog-content" }
const _hoisted_13 = { class: "download-box" }
const _hoisted_14 = { class: "upload-box" }
const _hoisted_15 = { class: "upload-content" }
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = { class: "edit-popup-box" }
const _hoisted_19 = { class: "form-error" }
const _hoisted_20 = { class: "error-table" }
const _hoisted_21 = { class: "receive" }
const _hoisted_22 = { class: "dialog-title" }
const _hoisted_23 = { class: "not-enough" }
const _hoisted_24 = { class: "not-enough" }
const _hoisted_25 = { class: "not-enough" }
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = { class: "confirm-info" }
const _hoisted_28 = { class: "info-item" }
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = { class: "info-item" }
const _hoisted_31 = { class: "info-item" }
const _hoisted_32 = { class: "info-item" }
const _hoisted_33 = { class: "info-item" }
const _hoisted_34 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_historyStaff = _resolveComponent("historyStaff")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawer) = $event)),
      direction: "rtl",
      size: "75%",
      "with-header": false,
      "close-on-click-modal": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, " 本次加保：" + _toDisplayString(_ctx.userList.length) + "人 ", 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form, {
                  inline: true,
                  model: _ctx.formSearch,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "员工" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formSearch.searchUserInfo,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.searchUserInfo) = $event)),
                          placeholder: "请输入员工姓名或身份证",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.onSearch
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode("搜索")
                          ])),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createTextVNode("重置")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAddHistoryStaff = true))
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode("在线选择")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onAddHandStaff
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("手动添加")
                ])),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                style: {"margin":"0 10px"},
                drag: false,
                disabled: false,
                "show-file-list": false,
                "file-list": _ctx.fileList,
                "before-upload": _ctx.onUpFile,
                "http-request": () => { },
                accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("导入名单")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "before-upload"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.downLoadTemp
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("模板下载")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_table, {
              data: _ctx.filterList,
              style: {"width":"100%"},
              height: "500px",
              "header-cell-style": { background: '#FBFBFD' },
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "userName",
                  label: "员工姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "idCardNo",
                  label: "身份证号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "insureEndTime",
                  label: "保单截止时间"
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                                    _ctx.editPersonnelInfo(
                                        scope.row.idCardNo,
                                        'alone',
                                        scope.row
                                    )
                                    )
                      }, " 编辑 ", 8, _hoisted_8),
                      _cache[30] || (_cache[30] = _createTextVNode(" | ")),
                      _createElementVNode("p", {
                        style: {"color":"#FF7E68"},
                        class: "point",
                        onClick: ($event: any) => (_ctx.deletePersonnel(scope.row.idCardNo))
                      }, " 删除 ", 8, _hoisted_9)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, { onClick: _ctx.cancelBack }, {
              default: _withCtx(() => _cache[31] || (_cache[31] = [
                _createTextVNode("取消并返回首页")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isChangeInsureInfo = true))
            }, {
              default: _withCtx(() => _cache[32] || (_cache[32] = [
                _createTextVNode("更换加保信息")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onConfirm
            }, {
              default: _withCtx(() => _cache[33] || (_cache[33] = [
                _createTextVNode("提交加保名单")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isAddHistoryStaff,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAddHistoryStaff) = $event)),
      title: "历史投保员工",
      width: "65%",
      "before-close": false
    }, {
      default: _withCtx(() => [
        (_ctx.isAddHistoryStaff)
          ? (_openBlock(), _createBlock(_component_historyStaff, {
              key: 0,
              onEmitAddStaff: _ctx.emitAddStaff
            }, null, 8, ["onEmitAddStaff"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isAddHandStaff,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isAddHandStaff) = $event)),
      title: _ctx.formHandTitle,
      width: "30%",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, { onClick: _ctx.onCloseAddHandStaff }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSaveAddHandStaff
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formHandStaff,
          ref: "handStaffRef",
          rules: _ctx.addHandStaffRules,
          "label-width": "100px",
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "员工姓名",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formHandStaff.userName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formHandStaff.userName) = $event)),
                  onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  placeholder: "请输入员工姓名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "身份证号",
              prop: "idCardNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formHandStaff.idCardNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formHandStaff.idCardNo) = $event)),
                  onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  placeholder: "请输入身份证号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isImportList,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isImportList) = $event)),
      title: "上传附件",
      width: "40%",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, { onClick: _ctx.onCloseImportList }, {
            default: _withCtx(() => _cache[40] || (_cache[40] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSaveImportList
          }, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { style: {"margin-bottom":"12px"} }, "下载导入模板，根据模版提示完善内容", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createTextVNode("下载模版")
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"margin-bottom":"12px"} }, "上传完善好的内容，仅支持xls格式，限10M以内，一次性最多上传1000条数据", -1)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                drag: "",
                accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                action: "https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_upload_filled)
                    ]),
                    _: 1
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "el-upload__text" }, [
                    _createTextVNode(" 将文件拖拽到此区域或 "),
                    _createElementVNode("em", null, "点击选择文件")
                  ], -1))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isChangeInsureInfo,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isChangeInsureInfo) = $event)),
      title: "更换加保信息",
      width: "450px",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, { onClick: _ctx.onCloseInsureInfo }, {
            default: _withCtx(() => _cache[43] || (_cache[43] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSaveInsureInfo
          }, {
            default: _withCtx(() => _cache[44] || (_cache[44] = [
              _createTextVNode(" 提交 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formChangeInsureInfo,
          ref: "changeInsureInfoRef",
          rules: _ctx.changeInsureInfoRules,
          "label-width": "130px",
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "保险方案",
              prop: "planCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formChangeInsureInfo.planCode,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formChangeInsureInfo.planCode) = $event)),
                  placeholder: "请选择保险方案",
                  onChange: _ctx.onPlanChange,
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "派遣单位",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formChangeInsureInfo.companyId,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formChangeInsureInfo.companyId) = $event)),
                  placeholder: "请选择派遣单位",
                  onChange: _ctx.onCompanyChange,
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "工种选择",
              prop: "workType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formChangeInsureInfo.workType,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formChangeInsureInfo.workType) = $event)),
                  placeholder: "请选择工种",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTypeList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "保单截止时间",
              prop: "date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formChangeInsureInfo.date,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formChangeInsureInfo.date) = $event)),
                  style: {"width":"198px"},
                  type: "date",
                  class: "date-solt point",
                  "disabled-date": _ctx.handleDisableDate,
                  "unlink-panels": "",
                  placeholder: "生效日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"margin-top":"-24px","color":"#9497B1","font-size":"12px"} }, {
              default: _withCtx(() => _cache[42] || (_cache[42] = [
                _createTextVNode(" 默认保障24小时，或者更换保障截止日期 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isFormError,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isFormError) = $event)),
      width: "450px",
      title: "名单格式错误人员",
      center: "",
      onClose: _ctx.onFormError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formErrorList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row row-uninsured",
              key: index
            }, [
              _createElementVNode("div", null, "姓名：" + _toDisplayString(item.name) + " 身份证：(" + _toDisplayString(item.code) + ")", 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.checkErrorShow,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.checkErrorShow) = $event)),
      width: "900px",
      title: "操作错误",
      center: "",
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.close()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_alert, {
            title: `以下人员身份信息错误，请修改后重新上传`,
            type: "error",
            center: "",
            "show-icon": ""
          }),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_table, {
              data: _ctx.enterErrorList,
              "header-row-style": { color: 'black' },
              "row-style": { border: 'none' },
              height: "600px",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "userName",
                  label: "姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "idCardNo",
                  label: "身份证号"
                }),
                _createVNode(_component_el_table_column, { label: "错误信息" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("p", null, _toDisplayString(scope.row.msg), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btn obtain",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.close()))
            }, " 知道了 ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.valueNotEnoughShow,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.valueNotEnoughShow) = $event)),
      title: "余额不足",
      width: "500px",
      "show-close": false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_icon, { style: {"color":"#D54941","font-size":"20px","margin-right":"4px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_CircleCloseFilled)
            ]),
            _: 1
          }),
          _cache[45] || (_cache[45] = _createTextVNode(" 余额不足 "))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.valueNotEnoughShow = false))
          }, {
            default: _withCtx(() => _cache[51] || (_cache[51] = [
              _createTextVNode(" 我知道了 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _cache[46] || (_cache[46] = _createTextVNode(" 您明日将有")),
            _createElementVNode("text", _hoisted_23, _toDisplayString(_ctx.notEnoughData.tomorrowNeedCostFee), 1),
            _cache[47] || (_cache[47] = _createTextVNode(" 元 的保费需要扣除， 而当前您的账户余额为")),
            _createElementVNode("text", _hoisted_24, _toDisplayString(_ctx.notEnoughData.currentBalance), 1),
            _cache[48] || (_cache[48] = _createTextVNode(" 元。 因此对于您本次预计扣除总计")),
            _createElementVNode("text", _hoisted_25, _toDisplayString(_ctx.notEnoughData.willEnsureCostFee), 1),
            _cache[49] || (_cache[49] = _createTextVNode(" 元的投保费用，账户余额不足以支付。"))
          ]),
          _cache[50] || (_cache[50] = _createElementVNode("div", null, " 为了顺利完成投保，请先进行充值，感谢配合！ ", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isConfirmInfo,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isConfirmInfo) = $event)),
      title: "确认信息",
      width: "450px",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_34, [
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isConfirmInfo = false))
          }, {
            default: _withCtx(() => _cache[65] || (_cache[65] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSaveConfirmInfo
          }, {
            default: _withCtx(() => _cache[66] || (_cache[66] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "info-item info-tip" }, [
            _createElementVNode("text", { class: "info-tip-label" }, "【温馨提示】"),
            _createTextVNode("出险后，超出48小时不可报案")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _cache[52] || (_cache[52] = _createElementVNode("text", { class: "info-item-label" }, "投保方案：", -1)),
            _cache[53] || (_cache[53] = _createTextVNode()),
            _createElementVNode("text", null, _toDisplayString(_ctx.formatter(_ctx.formChangeInsureInfo.planCode,_ctx.planList,{valueKey: 'value'})), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[54] || (_cache[54] = _createElementVNode("text", { class: "info-item-label" }, "派遣单位：", -1)),
            _cache[55] || (_cache[55] = _createTextVNode()),
            _createElementVNode("text", null, _toDisplayString(_ctx.formatter(_ctx.formChangeInsureInfo.companyId,_ctx.companyList,{valueKey: 'value'})), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[56] || (_cache[56] = _createElementVNode("text", { class: "info-item-label" }, "保障工种：", -1)),
            _cache[57] || (_cache[57] = _createTextVNode()),
            _createElementVNode("text", null, _toDisplayString(_ctx.formatter(_ctx.formChangeInsureInfo.workType,_ctx.workTypeList,{valueKey: 'value'})), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[58] || (_cache[58] = _createElementVNode("text", { class: "info-item-label" }, "加保人数：", -1)),
            _cache[59] || (_cache[59] = _createTextVNode()),
            _createElementVNode("text", null, _toDisplayString(_ctx.userList.length) + " 人", 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[60] || (_cache[60] = _createElementVNode("text", { class: "info-item-label" }, "预计扣除：", -1)),
            _cache[61] || (_cache[61] = _createTextVNode()),
            _createElementVNode("text", null, "¥" + _toDisplayString(_ctx.priceValue), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[62] || (_cache[62] = _createElementVNode("text", { class: "info-item-label" }, "保单截止日期：", -1)),
            _cache[63] || (_cache[63] = _createTextVNode()),
            _createElementVNode("text", null, _toDisplayString(_ctx.formChangeInsureInfo.date), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}